<template>
    <scenario-list-item-base v-bind:scenario="scenarioBatch" v-bind:class="{'deactivated-batch': isCancelled}">
        <template v-slot:bottom>
            <scenario-deactivation-confirmation-popup
                ref="deactivationPopup"
                v-bind:scenario="scenarioBatch"
                @confirm="deactivate"
            >    
            </scenario-deactivation-confirmation-popup>
            
            <scenario-activation-confirmation-popup
                ref="activationPopup"
                v-bind:scenario="scenarioBatch"
                @confirm="activate"
            >
            </scenario-activation-confirmation-popup>


            <div class="scenario-list-item-content">
                <div>
                    <div class="row form-group">
                        <div class="col-3">
                        <span class="dmv-text dmv-text-secondary">
                            {{resource('DmvScenarioActiveBatchListModel_EstimatedCosts_Label')}}:
                        </span>
                        </div>
                        <div class="col">
                            <span class="dmv-text dmv-text-secondary">&euro;&nbsp;{{estimatedCosts}},-</span>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-3">
                        <span class="dmv-text dmv-text-secondary">
                            {{resource('DmvScenarioActiveBatchListModel_EstimatedRecipients_Label')}}:
                        </span>
                        </div>
                        <div class="col-9">
                            <span class="dmv-text dmv-text-important estimate-costs">{{estimatedRecipients}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div v-if="canEdit" class="scenario-list-item-content edit-btn-container">
                <span class="pull-right dmv-text dmv-text-secondary mdb-icon-btn edit" @click="edit">
                    <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </span>
            </div>
        </template>
    </scenario-list-item-base>
</template>

<script>
    import resourceMixin from '../../../../Util/Mixins/resources'
    
    import dmVisualizerApi from '../../../../Api/dm-visualizer'
    import growler from "../../../../Util/growler";
    
    import ScenarioListItemBase from "./../ScenarioListItemBase.vue";
    import ScenarioDeactivationConfirmationPopup from "./ScenarioDeactivationConfirmationPopup.vue";
    import ScenarioActivationConfirmationPopup from "./ScenarioActivationConfirmationPopup.vue";
    
    export default {
        name: "scenario-overview-list-item",
        mixins: [resourceMixin],
        components: {
            ScenarioActivationConfirmationPopup,
            ScenarioDeactivationConfirmationPopup,
            ScenarioListItemBase
        },
        created(){
            const vm = this;
            
            dmVisualizerApi.validateWritePermission().then(
                canWrite => vm.canWrite = canWrite
            );
        },
        methods: {
            edit(){
                //Cancelled can get re-activated
                //active can be cancelled
                if(this.isCancelled){
                    this.showActivationPopup();
                }
                else{
                    this.showDeactivationPopup();   
                }
            },
            deactivate(){
                this.$emit('deactivate');
                this.hideDeactivationPopup();
            },
            activate(){
                this.$emit('activate');
                this.hideActivationPopup();
            },
            showDeactivationPopup(){
                this.$refs.deactivationPopup.show();
            },
            hideDeactivationPopup(){
                this.$refs.deactivationPopup.hide();
            },
            showActivationPopup(){
                this.$refs.activationPopup.show();
            },
            hideActivationPopup(){
                this.$refs.activationPopup.hide();
            }
        },
        computed: {
            canEdit(){
                //canCancel also determines whether we can re-activate
                return this.canWrite && this.canCancel;
            }
        },
        props: {
            scenarioBatch: {
                type: Object,
                required: true,
                default: () => ({
                    id: '',
                    name: '',
                    imageUrl: null,
                    description: '',
                    batchCancellationTextHeader: '',
                    batchCancellationText: '',
                    batchActivationTextHeader: '',
                    batchActivationText: ''
                })
            },

            canCancel: Boolean,
            isCancelled: Boolean,
            estimatedCosts: Number,
            estimatedRecipients: Number
        },
        data: () => ({
            canWrite: false
        })
    }
</script>

<style scoped src="../../Style/scenario-batch-list-item.scss" lang="scss">
</style>
